import { ruleMessage } from '@cnamts/vue-dot/src/helpers/ruleMessage';
import { ErrorMessages } from '@cnamts/vue-dot/src/rules/types';

const defaultErrorMessages: ErrorMessages<number> = {
	default: (lengthValue: number) => `La longueur du champ doit être de ${lengthValue} caractères.`
};

/** Check that the field exceeds the lengthValue length */
export function exactLength(
	lengthValue: number,
	ignoreSpaces = false,
	errorMessages = defaultErrorMessages
) {
	// Return the validation function
	return (value: string) => {
		// If the value is empty, return true (valid)
		if (!value) {
			return true;
		}

		if (ignoreSpaces) {
			value = value.replace(/\s/g, '');
		}

		return value.length === lengthValue || ruleMessage(errorMessages, 'default', [lengthValue]);
	};
}

export default exactLength;
